import React, { useState } from "react";
import { ChevronDown, ChevronUp, Trash2 } from "lucide-react";
import ProjectDetails from "./ProjectDetails";

const ProjectRow = ({ project, onDelete, onUpdate }) => {
  const [isOpen, setIsOpen] = useState(false);

  // Récupération des traductions FR/EN
  const fr = project.translations.find((t) => t.language_code === "fr");
  const en = project.translations.find((t) => t.language_code === "en");

  return (
    <>
      <tr
        onClick={() => setIsOpen(!isOpen)}
        className={`transition-colors duration-200  ${
          isOpen ? "bg-white" : "hover:bg-white"
        }`}
      >
        <td className="w-1/5 px-6 py-3 border-b border-light dark:border-white text-sm font-medium text-dark">
          {fr?.title || en?.title || "Titre non défini"}
        </td>
        <td className="w-1/5 px-6 py-3 border-b border-light dark:border-white text-sm text-dark">
          {project.category}
        </td>
        <td className="w-2/5 px-6 py-3 border-b border-light dark:border-white text-sm text-dark">
          {fr?.description?.substring(0, 50) ||
            en?.description?.substring(0, 50)}
          ...
        </td>
        <td className="w-1/5 px-6 py-3 border-b border-light dark:border-white text-sm text-dark">
          {project.secondaryImages?.length > 0
            ? `${project.secondaryImages.length} image(s) supplémentaire(s)`
            : "Aucune"}
        </td>
        <td className="px-6 py-3 border-b border-light dark:border-white text-sm text-dark">
          {new Date(project.created_at).toLocaleDateString()}
        </td>
        <td className="px-6 py-3 border-b border-light dark:border-white text-center">
          <div className="flex items-center justify-center space-x-2">
            {isOpen ? (
              <ChevronUp className="w-5 h-5 text-dark" />
            ) : (
              <ChevronDown className="w-5 h-5 text-dark" />
            )}
            <Trash2
              className="w-5 h-5 text-red-600 hover:text-red-800"
              onClick={(e) => {
                e.stopPropagation();
                onDelete(project);
              }}
            />
          </div>
        </td>
      </tr>

      {isOpen && (
        <tr>
          <td colSpan={6} className=" bg-mdlight border-t border-white">
            <ProjectDetails
              project={project}
              onDelete={onDelete}
              onUpdate={onUpdate}
            />
          </td>
        </tr>
      )}
    </>
  );
};

export default ProjectRow;
